import { forwardRef, useState } from 'react';
import { Send } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from '../ui';

export interface ChatInputProps {
  onSendMessage: (message: string) => void;
  isDisabled?: boolean;
  placeholder?: string;
  className?: string;
}

const ChatInput = forwardRef<HTMLFormElement, ChatInputProps>(
  (
    { onSendMessage, isDisabled = false, placeholder = 'Digite sua mensagem...', className },
    ref
  ) => {
    const [message, setMessage] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
      e.preventDefault();
      if (!message.trim() || isDisabled) return;

      onSendMessage(message);
      setMessage('');
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleSubmit(e);
      }
    };

    return (
      <form ref={ref} onSubmit={handleSubmit} className={cn('flex gap-3 items-end', className)}>
        <input
          type="text"
          value={message}
          onChange={e => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          disabled={isDisabled}
          className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 dark:bg-gray-700 dark:text-white"
        />
        <Button type="submit" disabled={!message.trim() || isDisabled}>
          <Send className="h-4 w-4" />
        </Button>
      </form>
    );
  }
);

ChatInput.displayName = 'ChatInput';

export default ChatInput;
